let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9CDY0"), load("9RCI8")]).then(() => parcelRequire('2l8zZ'));